<ng-template #template let-row="row">
  <div *ngIf="row.orderingInformation?.siloDistributionRequirements !== noSilosNeeded; else noSiloDistribution" class="column-silo-distribution flex--row">
    <!-- Add/modify button -->
    <div class="column-silo-distribution__button-wrapper">
      <button mat-button data-test="column-silo-distribution__add-modify-silos" class="button--text" (click)="openSiloDistribution(row)" *ngIf="editable">
        <mat-icon>{{ row.silos?.length ? 'edit' : 'add' }}</mat-icon>
        <span *ngIf="!row.silos?.length">
          {{ 'cart.silo.add-silo' | translate }}
        </span>
      </button>
    </div>

    <!-- Silo distribution -->
    <div *ngIf="row.silos?.length" class="silo-information-wrapper flex--column">
      <div *ngFor="let silo of row.silos" class="silo-information flex__child flex--row">
        <div>Silo {{ silo.siloNumber }}</div>
        <div class="silo-information__quantity flex__child text--gray">
          {{
            silo.distributionType !== 'Exact'
              ? ('cart.silo.silo-' + silo.distributionType | translate)
              : (silo.quantity | agrNumber) + ('unit.' + row.orderingInformation?.orderUnit | translate)
          }}
        </div>
      </div>
    </div>
  </div>

  <ng-template #noSiloDistribution>-</ng-template>
</ng-template>
